import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-verification-detail-question-modal',
  templateUrl: './verification-detail-question-modal.component.html',
  styleUrls: ['./verification-detail-question-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatFormField,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule
  ]
})
export class VerificationDetailQuestionModalComponent {

  question?: string;

  constructor(private dialogRef: MatDialogRef<VerificationDetailQuestionModalComponent>) { }

  onSendClick(): void {
    this.dialogRef.close(this.question);
  }

  onCancelClick(): void {
    this.dialogRef.close(null);
  }
}